'use client';

import { ActionButton } from '@/components/action-button';
import { Show } from '@/components/conditional-component';
import { useUser } from '@/components/providers/user-provider';
import { WhatsappSupport } from '@/components/whatsapp-support';
import { useRazorpayPayment } from '@/hooks/use-razorpay-payment';
import { Loader2 } from 'lucide-react';
import { useRouter } from 'next/navigation';
import * as React from 'react';
import { useBatch } from '../providers/batch-provider';
export function JoinSection({
  isLoggedIn
}: {
  isLoggedIn: boolean;
}) {
  const router = useRouter();
  const {
    batch,
    isNotValid
  } = useBatch();
  const {
    user
  } = useUser();
  const {
    processPayment,
    isLoading
  } = useRazorpayPayment({
    batchId: batch?.id,
    userDetails: {
      name: user?.name,
      // email: user?.email,
      contact: user?.phone
    },
    onSuccess: () => {
      // Optional: Add any additional success handling specific to this component
    },
    onError: error => {
      // Optional: Add any additional error handling specific to this component
      console.error('Payment failed', error);
    }
  });
  const handleBookNow = async () => {
    if (isLoggedIn) {
      await processPayment();
    } else {
      router.replace('/login');
    }
  };
  return <div className="mb-24 flex min-h-2 flex-col items-start self-stretch px-3 py-4 md:mb-0 md:px-6" data-sentry-component="JoinSection" data-sentry-source-file="join-section.tsx">
      {/* Fee Details Section */}
      <div className="flex flex-col items-start self-stretch">
        <div className="w-full rounded-lg bg-white p-4 md:border-[0.5px] md:border-black/10 md:shadow-[0px_2px_6px_0px_rgba(0,0,0,0.09)]">
          <div className="flex h-14 justify-between py-2">
            <span className="text-base">{batch?.fees.componentType === 'Admission' ? 'Admission Fee' : 'Coaching Fee'}</span>
            <span className="font-medium">
              {' '}
              ₹
              {batch?.fees.amount}
            </span>
          </div>
          <Show when={!!batch?.fees.gst} data-sentry-element="Show" data-sentry-source-file="join-section.tsx">
            <div className="flex h-14 justify-between py-2">
              <span className="text-base">GST (18%)</span>
              <span className="font-medium">
                {' '}
                ₹
                {batch?.fees.gst}
              </span>
            </div>
          </Show>
          <div className="flex h-14 justify-between border-t py-2">
            <span className="text-base">Total Fee</span>
            <span className="font-semibold">
              ₹
              {batch && (batch.fees.amount + batch.fees.gst).toLocaleString('en-IN')}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2 w-full md:block">
        <ActionButton onClick={handleBookNow} className={`${isNotValid ? 'pointer-events-none grayscale' : ''}`} data-sentry-element="ActionButton" data-sentry-source-file="join-section.tsx">
          {isLoading ? <Loader2 className="size-6 animate-spin text-white" /> : batch?.own ? 'Enrolled' : batch?.fees.isFree ? `Join Now For Free` : `${batch?.fees.componentType === 'Admission' ? 'Book for' : 'Join Now for'} ₹${batch && (batch.fees.amount + batch.fees.gst).toLocaleString('en-IN')}`}
        </ActionButton>
      </div>
      <WhatsappSupport data-sentry-element="WhatsappSupport" data-sentry-source-file="join-section.tsx" />
    </div>;
}